// Packages
import React from 'react';

// Components
import { KiteCard } from '@kite/react-kite';
import './SpectrumDiyTotal.scss';

export interface ISpectrumDiyTotalProps {
  title: string;
  primaryCostLabel: string;
  primaryCost: string;
  secondaryCostLabel?: string;
  secondaryCost?: string;
  isDiy?: boolean;
}

const SpectrumDiyTotal = ({
  title,
  primaryCostLabel,
  primaryCost,
  secondaryCostLabel,
  secondaryCost,
  isDiy = false,
}: ISpectrumDiyTotalProps) => {
  // =============================================
  // Helpers (Memo, CB, vars)
  // =============================================

  return (
    <KiteCard className="total-cost-card">
      <div className={`title ${isDiy ? 'diy' : 'spectrum-total'}`}>
        <h3>{title}</h3>
      </div>
      <div
        className={`total-cost-section ${
          secondaryCostLabel ? 'grids-col-2' : 'grids-col-1'
        }`}
      >
        <div className="total-cost-row">
          <span className="cost-label">{primaryCostLabel}</span>
          <h2 className="total-cost">{primaryCost}</h2>
        </div>
        {secondaryCostLabel && (
          <div className="total-cost-row">
            <span className="cost-label">{secondaryCostLabel}</span>
            <h2 className="total-cost">{secondaryCost}</h2>
          </div>
        )}
      </div>
    </KiteCard>
  );
};

export default SpectrumDiyTotal;
